// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"312":"578f8c65","350":"8276e61d","612":"1eb8d9e7"}[chunkId] + ".chunk.js";
};